<nav class="navbar navbar-expand-lg navbar-dark bg-primary py-0">
    <div class="navbar-content-outer">
        <div class="navbar-content-inner">
            <a href="/" class="navbar-brand logo">
                <div class="logo_govgr logo_small"></div>
            </a>

            <div class="nav_title pr-1">
                <a
                    class="nav_title"
                    tabindex="0"
                    role="button"
                    aria-disabled="false"
                    [routerLink]="'/'"
                >
                    <h3 class="nav_title">Μεταβίβαση Ακινήτου</h3>
                </a>
            </div>
            <!-- <div *ngIf="false" class="nav_title d-none d-lg-block">
                <a
                    class="nav_title"
                    tabindex="0"
                    role="button"
                    aria-disabled="false"
                    href="/"
                >
                    <h3
                        class="nav_title"
                        style="color: #cbcbcb; font-size: 1.3rem"
                    >
                        Υπουργείο Ανάπτυξης και Επενδύσεων - ΥΜΣ <br />
                        Ανεξάρτητη Αρχή Δημοσίων Εσόδων
                    </h3>
                </a>
            </div> -->
             <span style="flex: 1 1 auto"></span>
            <input
                type="text"
                class="form-control form-control-sm"
                [value]="selectedCitizen"
                (change)="onChange($event)"
                style="width: 150px"
            />
            <span style="flex: 1 1 auto"></span>
            <div *ngIf="showUser$ | async">
                <div
                    *ngIf="userInfo$ | async as user"
                    class="d-flex align-items-center"
                    style="color: white"
                >
                    <span class="d-none d-md-block pr-2"
                        >{{ user.firstName }} {{ user.lastName }}
                    </span>
                    <span
                        class="material-icons logout-icon"
                        tooltipClass="custom-tooltip-class"
                        ngbTooltip="Έξοδος"
                        (click)="logout(user)"
                        >logout</span
                    >
                </div>
            </div>
        </div>
    </div>
</nav>
